import React from 'react'

const SmallBarChartPreviewall = ({ value, maturityScale, lavel }) => {
  const importanceLabels = {
    1: "Not at all Important",
    2: "Low Importance",
    3: "Moderately Important",
    4: "Highly Important",
    5: "Critically Important",
  };

  return (
    <>
      <div className="small_bar_chart">
        <div className="bar-chart">
          {[1, 2, 3, 4, 5].map((level) => (
            <div
              key={level}
              className={`bar ${value === level ? 'filled' : ''}`}
              style={{ height: `${level * 10}px` }}
            ></div>
          ))}


        </div>
        <p>  {importanceLabels[value] || "No selection"}</p>

      </div>
    </>

  );
}

export default SmallBarChartPreviewall